import { BaseUserToken } from './common';

/**
 * @class Default user token for anonymous users
 */
export class AnonymousUserToken extends BaseUserToken {}
